import { render, staticRenderFns } from "./AlertSemDadosParaEtapa.vue?vue&type=template&id=87fcf506&scoped=true&"
import script from "./AlertSemDadosParaEtapa.vue?vue&type=script&lang=js&"
export * from "./AlertSemDadosParaEtapa.vue?vue&type=script&lang=js&"
import style0 from "./AlertSemDadosParaEtapa.vue?vue&type=style&index=0&id=87fcf506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fcf506",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFadeTransition,VIcon,VProgressCircular,VRow})
